module.exports = __webpack_public_path__ + "8f80d3f9d62c5191601f7284e0bfd27d.gif";